import {formatNumber} from './number';
import format from 'date-fns/format';
import axios from 'axios/index';
import {formatCurrency} from './currency';

export function attemptAddToCart(products) {
  return new Promise(resolve => {
    if (!products.length) {
      return resolve(false);
    }

    const maxSpecialShipDays = Math.max(...products.map(product => product.specialShipDays));
    const maxBackorderShipDays = Math.max(...products.map(product => product.backorderShipDays));

    // filter special order items, and process ship date
    const specialOrderProducts = products
      .filter(product => product.specialShipDays)
      .map(product => Object.assign({}, product, {
        specialShipDate: product.specialShipDays ? format(product.specialShipDate * 1000, 'dddd, MMMM Do') : '',
      }));
    const backorderProducts = products
      .filter(product => product.backorderShipDays)
      .map(product => Object.assign({}, product, {
        backorderShipDate: product.backorderShipDays ? format(product.backorderShipDate * 1000, 'dddd, MMMM Do') : '',
      }));

    const finishAddingToCart = (excludedIds = []) => new Promise(resolve => {
      // filter products which have been excluded
      const productsToAdd = products.filter(product => !excludedIds.includes(product.id));

      // exit if no products to add
      if (!productsToAdd.length) {
        resolve(false);
        return;
      }

      // check if multiple products
      if (productsToAdd.length > 1) {
        let queryParams = [],
          productIds = [];

        productsToAdd.map(product => {
          queryParams.push(`qty${product.id}=${product.qty}`);
          productIds.push(product.id);
        });

        // if more than one product, redirect to cart pge
        window.location.href = `${ROOT_URL}/addtocart.php?cart=add&hidSelIds=${productIds.join(',')}&${queryParams.join('&')}`;

      } else {
        // get first product
        const product = productsToAdd[0];

        axios.post(`${ROOT_URL}/api/add-to-cart`, {id: product.id, qty: product.qty}, { withCredentials: true })
          .then(() => axios.get(`${ROOT_URL}/api/get-shopping-cart?_=${new Date().getTime()}`, { withCredentials: true }))
          .then(response => {
            resolve(true);

            const cart = response.data;
            window.showAddedToCartModal(product, cart);
            window.updateHeaderCartStatus(`${cart.total > 99 ? '99+' : cart.total} ${cart.total === 1 ? 'item' : 'items'} ($${parseFloat(cart.subtotal).toLocaleString('en-US', {minimumFractionDigits: 2})})`);
        });
      }
    });

    if (specialOrderProducts.length && maxSpecialShipDays >= maxBackorderShipDays) {
      window.showSpecialOrdersModal(specialOrderProducts, excludedIds => finishAddingToCart(excludedIds).then(resolve), 'specialShipDate');
    } else if (backorderProducts.length) {
      window.showSpecialOrdersModal(backorderProducts, excludedIds => finishAddingToCart(excludedIds).then(resolve), 'backorderShipDate');
    } else {
      finishAddingToCart().then(resolve);
    }
  });
}
